import label from "@/lang/StaticLabels.js";
import { devRouteName } from "@/config/underDevelopmentModules.js";

// PDEV Navbar  - ماژول‌های در حال توسعه ------------------------------------
// منوی سایدبار برای ماژول‌هایی که هنوز صفحه‌ای ندارند؛ تنها داشبورد
// «در حال توسعه» همان ماژول نمایش داده می‌شود.
export function buildUnderDevelopmentNav(moduleInfo) {
  if (!moduleInfo) return [];

  return [
    {
      title: moduleInfo.title,
      icon: "mdi-progress-wrench",
      to: false,
    },
    {
      to: devRouteName(moduleInfo),
      metaLabel: moduleInfo.title,
      label: label.menu.dashboard,
      icon: "pi pi-home",
      active: false,
      subItems: false,
    },
  ];
}

export default buildUnderDevelopmentNav;
